import type { HttpClient } from '@/lib/http/client.js'
import type { CreateWidgetInput, UpdateWidgetInput, Widget, WidgetImpact, WidgetSearch, WidgetWriteResult } from '@/types/widget/widget.type.js'

/** `admin/widgets`, verified against `widget-admin.controller.ts`. The list is an array. */
export interface WidgetService {
  list: (query: WidgetSearch) => Promise<readonly Widget[]>
  get: (id: string) => Promise<Widget>
  /** What a change would reach. Read before editing a shared default. */
  impact: (id: string) => Promise<WidgetImpact>
  create: (input: CreateWidgetInput) => Promise<WidgetWriteResult>
  update: (id: string, input: UpdateWidgetInput) => Promise<WidgetWriteResult>
  /** 204. Refused while live promotions use it, or shops hold copies of a default. */
  remove: (id: string) => Promise<void>
}

export function createWidgetService(http: HttpClient): WidgetService {
  return {
    list: (query) => http.get<readonly Widget[]>('admin/widgets', { query: { ...query } }),
    get: (id) => http.get<Widget>(`admin/widgets/${encodeURIComponent(id)}`),
    impact: (id) => http.get<WidgetImpact>(`admin/widgets/${encodeURIComponent(id)}/impact`),
    create: (input) => http.post<WidgetWriteResult>('admin/widgets', input),
    update: (id, input) => http.patch<WidgetWriteResult>(`admin/widgets/${encodeURIComponent(id)}`, input),
    remove: async (id) => {
      await http.delete(`admin/widgets/${encodeURIComponent(id)}`)
    },
  }
}
